import { render, staticRenderFns } from "./infoServices.vue?vue&type=template&id=28ab3f7b&scoped=true&"
import script from "./infoServices.vue?vue&type=script&lang=js&"
export * from "./infoServices.vue?vue&type=script&lang=js&"
import style0 from "./infoServices.vue?vue&type=style&index=0&id=28ab3f7b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab3f7b",
  null
  
)

export default component.exports